// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { GITSHA } from "./version";

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBWk1ghjNmnSPlVAd8gm0gA_-FnuDHDxFA",
    authDomain: "rainfall-9a028.firebaseapp.com",
    databaseURL: "https://rainfall-9a028.firebaseio.com",
    projectId: "rainfall-9a028",
    storageBucket: "rainfall-9a028.appspot.com",
    messagingSenderId: "227837825304"
  },
  gitsha: GITSHA
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
